<template>
  <div class="crop-list">
    <CropButton
      v-for="crop in crops"
      :key="crop"
      :crop="crop"
      :isSelected="isCropSelected(crop)"
      @click="handleClick(crop)"
    />
  </div>
</template>

<script>
import CropButton from '../shared/CropButton';

export default {
  components: {
    CropButton
  },
  props: {
    modelValue: {
      type: String,
      default: '',
      required: true
    },
    crops: {
      type: Array,
      required: true
    },
    selectedCrop: {
      type: String,
      required: false,
      default: null
    }
  },
  emits: ['update:modelValue'],
  methods: {
    isCropSelected(crop) {
      return crop === this.modelValue;
    },
    handleClick(crop) {
      this.$emit('update:modelValue', crop);
    }
  }
};
</script>

<style lang="scss" scoped>
.crop-list {
  align-items: flex-start;
  display: flex;
  flex-wrap: wrap;

  > * {
    margin: spacing('xs') spacing('sm') spacing('xs') 0;
  }

  @media (max-width: 320px) {
    justify-content: center; 
  }
}
</style>
